module.exports = __webpack_public_path__ + "static/media/facebook-hover.27e6349e.svg";